import { useEffect, useRef } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Slide, { type SlideProps } from '@mui/material/Slide';
import { useNumber } from '@/hooks/useNumber';
import Card from '@/components/Card';
import Spinner from '@/components/Spinner';
import { CheckIcon } from '@/icons';
import { classes } from './utils';

export type DownloadToasterProps = {
  open: boolean;
  isLoading: boolean;
  message?: string;
  successMessage?: string;
  onClose: () => void;
};

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="left" />;
}

export default function DownloadToaster({
  open,
  isLoading,
  message = 'Preparing download...',
  successMessage = 'Download complete',
  onClose,
}: DownloadToasterProps) {
  const wasLoading = useRef(isLoading);
  const [duration, setDuration, clearDuration] = useNumber(null);

  useEffect(() => {
    if (!isLoading && wasLoading.current) {
      setDuration(2000);
      wasLoading.current = false;
    } else if (isLoading && !wasLoading.current) {
      clearDuration();
      wasLoading.current = true;
    }
  }, [isLoading]);

  const handleClose = () => {
    setTimeout(() => onClose(), 2000);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      TransitionComponent={SlideTransition}
      onClose={handleClose}>
      <div className={classes.wrapper}>
        <Card className={classes.card}>
          {isLoading ? (
            <Spinner size={20} />
          ) : (
            <CheckIcon className={classes.icon} />
          )}
          <div className={classes.message}>
            {isLoading ? message : successMessage}
          </div>
        </Card>
      </div>
    </Snackbar>
  );
}
